/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, SetStateAction } from "react";
import Client from "./Client.type";

export interface ClientContext {
    client: Partial<Client | undefined>;
    setClient: React.Dispatch<SetStateAction<Partial<Client | undefined>>>;
}

export const ClientContextLayout = createContext<ClientContext>({
    client: {},
    setClient: () => {},
});

export default ClientContextLayout;
